import ContentScale from '../ContentScale/ContentScale'

import getLeftTop from './utils/getLeftTop'
import getTranslateDirection from './getTranslateDirection'

import type { ITranslate } from './definitions'

/**
 * Két Element közti távolság animálásához szükséges adatok.
 * @param from       - Honnan.
 * @param to         - Hova.
 * @param toCenter   - Középpontos viszonyítás.
 * @param scaleRatio - Scale mértéke (contenScale miatt).
 */
export default function calculateTranslate ( // eslint-disable-line @typescript-eslint/max-params -- Legacy.
  from: HTMLElement,
  to: HTMLElement,
  toCenter = false,
  scaleRatio?: string
): ITranslate {
  const ratio = scaleRatio ?? ContentScale.getScaleRatio()

  const fromRect = ContentScale.getElementOffset(from, ratio)
  const toRect   = ContentScale.getElementOffset(to, ratio)

  const [ fromLeft, fromTop ] = getLeftTop(fromRect, toCenter)
  const [ toLeft, toTop ]     = getLeftTop(toRect, toCenter)

  return getTranslateDirection(fromLeft, toLeft, fromTop, toTop)
}
